import { useForm, FormProvider } from 'react-hook-form';
import { CompanyDto } from 'tdc-web-backend/companies/schemas';
import { useTranslation } from 'react-i18next';
import { TimedProjectEditorMenu } from '../../../../../../../../../../components/editor/menu-option-lists/menu-item-lists';
import { ReactComponent as ClipboardCheckIcon } from '../../../../../../../../../../assets/icons/layout-icons/ClipboardCheckIconEditModal.svg';
import ConfirmModal from '../../../../../../../../../../components/confirm-modal/ConfirmModal';
import { primaryLight } from '../../../../../../../../../../utils/color';
import { useRefresh } from '../../../../../../../../../../utils/hooks/crud-hooks/useRefresh';
import ControlledTextEditor from '../../../../../../../../../../components/custom-inputs/ControlledTextEditor';
import useUserCompany from '../../../../../../../../../../utils/hooks/useUserCompany';

interface EditCompanyAboutProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditCompanyAbout = ({ isModalOpen, setIsModalOpen }: EditCompanyAboutProps) => {
  const refresh = useRefresh();
  const { company: companyData, updateCompany, isLoadingUpdateCompany } = useUserCompany();
  const { t } = useTranslation();
  const methods = useForm<Partial<CompanyDto>>({
    mode: 'onChange',
    defaultValues: {
      description: companyData?.description,
    },
  });

  const onSubmit = (data: any) => {
    updateCompany(data, {
      onSuccess: () => {
        refresh();
        setIsModalOpen(false);
      },
    });
  };

  return (
    <ConfirmModal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      onCancel={() => setIsModalOpen(false)}
      onConfirm={methods.handleSubmit(onSubmit)}
      automaticallyCloseModalOnButtonClick={false}
      confirmButtonText={t('common.save')}
      title={t('settings.companyProfile.aboutYourCompany')}
      width={'40%'}
      isLoading={isLoadingUpdateCompany}
      iconProps={{
        icon: <ClipboardCheckIcon fill={primaryLight[500]} />,
        wrapperBackgroundColor: '#E3DBFC',
      }}
      message={
        <FormProvider {...methods}>
          <ControlledTextEditor name="description" items={TimedProjectEditorMenu} required />
        </FormProvider>
      }
    />
  );
};

export default EditCompanyAbout;
